import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from 'src/app-core/services/common.service';
import { ZipcodeDataModel } from './zipcode-data-modal';
import { finalize } from 'rxjs/operators';
import { CountryLookupEnum } from '../app-common-enum';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { NgForm } from '@angular/forms';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-add-national-zipcode-dialog',
    templateUrl: './add-national-zipcode-dialog.component.html',
    styleUrls: ['./add-national-zipcode-dialog.component.scss']
})
export class AddNationalZipcodeDialogComponent implements OnInit {

    @ViewChild('zipcodeForm', { static: false }) zipcodeForm: NgForm;
    isFormLoading = false;
    tenantList: any;
    tenantListFiltered: any;
    zipcodeDataModel = new ZipcodeDataModel();
    zipcodeModel = this.zipcodeDataModel.zipcodeModel;
    zipcodeFormDataModel: any = this.zipcodeDataModel.zipCodeFormPayload
    countries: any = [];
    copyCountriesList: any = [];
    countryLookupEnum: typeof CountryLookupEnum = CountryLookupEnum;
    zipcodeDetails: any;
    zipcodeData: any;
    isEditMode = false;

    constructor(
        public dialog: MatDialog,
        private dialogRef: MatDialogRef<AddNationalZipcodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private commonService: CommonService,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        this.onLoadItems();
        this.zipcodeData = _.cloneDeep(this.data);
        this.zipcodeFormDataModel = this.zipcodeDataModel.zipCodeFormPayload
        if (this.zipcodeData.zip) {
            this.isEditMode = true;
            this.getZipCodeDetails();
            this.zipcodeFormDataModel = this.zipcodeDataModel.zipCodeFormPayload;
        }
        else {
            this.isEditMode = false;
            this.zipcodeFormDataModel = this.zipcodeDataModel.zipCodeFormPayload;
        }
    }

    onLoadItems() {
        this.getTenantList();
        this.getCountries();
    }

    clearLocationDetails() {
        this.zipcodeFormDataModel.province = null;
        this.zipcodeFormDataModel.city = '';
    }

    getCountries(): void {
        this.commonService.getCountries().subscribe(response => {
            if (response.isSuccess) {
                this.countries = response.data.map((country: {
                    id: { toString: () => any; };
                }) => Object.assign(country, { id: country.id }));
            }
            this.copyCountriesList = this.countries;
            if (!this.zipcodeDetails) {
                this.zipcodeFormDataModel.countryId = 1;
            }
        });
    }

    onCountryChange() {
        this.zipcodeFormDataModel.province = null;
        this.zipcodeFormDataModel.city = null;
        this.zipcodeFormDataModel.zipCode = null;
    }

    getTenantList(): void {
        this.commonService.getTanentList().subscribe((response: any) => {
            response.data.splice(0, 1);
            this.tenantList = response.data;
            this.tenantListFiltered = response.data;
        });
    }

    onChangeTenant(event: any): void {
        this.zipcodeModel.assignedTenantCode = event.code;
    }

    onTerritoryHandleFilter(value: any) {
        this.tenantList = this.tenantListFiltered.filter((s) =>
            s.name.toLowerCase().includes(value.toLowerCase()) ||
            s.code.toLowerCase().includes(value.toLowerCase())
        );
    }

    onCountryHandleFilter(value: any) {
        this.countries = this.copyCountriesList.filter((s) => s.countryName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
    }

    onSave(): void {
        if (this.isEditMode) {
            this.onUpdateZipCode();
        } else {
            this.onAddZipCode();
        }
    }

    onUpdateZipCode() {
        let zipcodeFormDataModel = _.cloneDeep(this.zipcodeFormDataModel);
        this.isFormLoading = true;
        this.commonService.UpdateZipcode(zipcodeFormDataModel)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    const sendingData = {
                        confirmResult: true,
                    };
                    this.dialogRef.close(sendingData);
                    this.toastr.success(response.errors || CommonConstants.appComponent.updatedSuccessfully);
                } else {
                    this.toastr.warning(response.errors);
                }
            });
    }

    onAddZipCode() {
        this.isFormLoading = true;
        const zipcodeFormDataModel = _.cloneDeep(this.zipcodeFormDataModel);
        this.commonService.AddZipcode(zipcodeFormDataModel)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe((response: any) => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    const sendingData = {
                        confirmResult: true,
                    };
                    this.dialogRef.close(sendingData);
                    this.toastr.success(response.errors || CommonConstants.appComponent.addedSuccessfully);
                }
                else {
                    this.toastr.warning(response.errors);
                }
            });
    }

    getZipCodeDetails() {
        this.isFormLoading = true;
        let query = `${this.zipcodeData.zip}`;
        this.commonService.getZipcodeDetails(query)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                if (response.isSuccess) {
                    this.zipcodeFormDataModel.countryId = response.data.countryId;
                    this.zipcodeFormDataModel.province = response.data.province;
                    this.zipcodeFormDataModel.city = response.data.city;
                    this.zipcodeFormDataModel.zipCode = response.data.zip;
                    this.zipcodeFormDataModel.zipCodeId = response.data.zipCodeId;
                    this.zipcodeFormDataModel.tenantId = response.data.tenantId
                } else {
                    this.toastr.warning(response.errors);
                }
                this.isFormLoading = false;
            });
    }

    onClose() {
        this.dialogRef.close();
    }

}
